<template>
  <div class="main">
    <topImg
      img="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/banners/banner_chanpinzhongxin.png"
    ></topImg>
    <div class="content">
      <el-tabs v-model="tabSelected" @tab-click="tabChange" class="tab">
        <el-tab-pane label="教学产品"></el-tab-pane>
        <el-tab-pane label="管理平台"></el-tab-pane>
      </el-tabs>
      <div class="teacher" v-if="tabSelected == 0">
        <!-- 未来课堂 -->
        <div class="module weilai">
          <div>
            <div class="headline">5G+XR未来课堂</div>
            <div class="introduce">
              <img
                v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/chanpin_kehu/chanpin/xr.png'"
                alt=""
              />
              <div class="right">
                <div class="title">产品介绍</div>
                <div class="desc">
                  未来课堂将虚拟现实技术与实际教育教学知识点紧密结合，覆盖中小学语文、英语、科学、物理、
                  化学、生物、地理、历史、安全等10000+个XR教学课程资源，以多种形式灵活应用
                  于课堂教学、科技馆等不同场景，以优质VR教学资源为核心，打造与实际教育教学高度结合的高仿
                  真、沉浸式、可交互的一体化课堂。
                </div>
              </div>
            </div>
            <div class="character">
              <div class="left">
                <div class="headline">产品特性</div>
                <div class="list">
                  <div class="title">全沉浸互动教学</div>
                  <div class="desc">
                    学生在虚拟环境中通过高度参与互动、演练从而提高学习效率
                  </div>
                </div>
                <div class="list">
                  <div class="title">实时互动教学</div>
                  <div class="desc">
                    实时反馈学生操作数据、学习进度至管理平台，及时进行知识点解答
                  </div>
                </div>
                <div class="list">
                  <div class="title">课件自由组合</div>
                  <div class="desc">
                    老师备课时可将课件资源任意组合成课程，可添加课程相关的资源
                  </div>
                </div>
                <div class="list">
                  <div class="title">教学数据分析</div>
                  <div class="desc">
                    支持指导、考核、自主等多种教学模式，满足不同阶段的教学需求
                  </div>
                </div>
                <div class="list">
                  <div class="title">教学测评系统</div>
                  <div class="desc">
                    在虚拟课堂中可对学生进行考核、测评，根据学生答题情况自动评分
                  </div>
                </div>
                <div class="list">
                  <div class="title">强大的课堂管理</div>
                  <div class="desc">
                    跨平台使用，支持老师备课，课堂管理，设备监督等功能
                  </div>
                </div>
              </div>
              <div class="right">
                <img
                v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/chanpin_kehu/chanpin/xr_img.png'"
                alt=""
              />
              </div>
            </div>
          </div>
        </div>
        <!-- 智慧宫 -->
        <div class="module zhihui">
          <div>
            <div class="headline">智慧宫</div>
            <div class="introduce">
              <img
                v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/chanpin_kehu/chanpin/zhihuigong.png'"
                alt=""
              />
              <div class="right">
                <div class="title">产品介绍</div>
                <div class="desc">
                  智慧宫是一套模拟中学物理、化学、生物实验场景，提供规范的实验内容、自由化交互的VR虚拟仿真实验室，通过教育与技术的深度融合，给学校赋能，为老师减负、使学生开心、让家长放心，为学校、老师、家长带来全新的教学新体验。
                </div>
              </div>
            </div>
            <div class="character">
              <div class="left">
                <div class="headline">产品特性</div>
                <div class="list">
                  <div class="title">安全保障</div>
                  <div class="desc">
                    教学安全性强。解决传统实验中的高危操作、实验准备周期长、实验室不足等问题
                  </div>
                </div>
                <div class="list">
                  <div class="title">灵活自由</div>
                  <div class="desc">
                    高自由度的灵活操作。可以实现双手互动操作、虚拟实验操作动手能力更强
                  </div>
                </div>
                <div class="list">
                  <div class="title">扩展性强</div>
                  <div class="desc">
                    可编辑和扩展的习题系统。在线考试测评系统，考核更方便，让学生巩固知识点
                  </div>
                </div>
                <div class="list">
                  <div class="title">管控性强</div>
                  <div class="desc">
                    强大的后端管控功能。全面的监管系统，学生与设备状态一目了然
                  </div>
                </div>
                <div class="list">
                  <div class="title">全面监测</div>
                  <div class="desc">
                    提高实验监测效能。教师可在管理平台实时监测全部学生操作情况
                  </div>
                </div>
                <div class="list">
                  <div class="title">数据分析</div>
                  <div class="desc">
                    教学数据分析系统。多维度数据分析报告，更快找到教学问题所在
                  </div>
                </div>
              </div>
              <div class="right">
                <img
                v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/chanpin_kehu/chanpin/zhihuigong_img.png'"
                alt=""
              />
              </div>
            </div>
          </div>
        </div>
        <!-- 格灵世界PC -->
        <div class="module gelinpc">
          <div>
            <div class="headline">格灵世界-PC编程版</div>
            <div class="introduce">
              <img
                v-lazy="'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/abbd58d2443a9c09e328822c3752a824.png'"
                alt=""
              />
              <div class="right">
                <div class="title">产品介绍</div>
                <div class="desc">
                  格灵世界编程版是在线STEAM课程平台，可满足“编程教育”、“创客教育”、“虚拟现实”、“项目式学习”、PBL、“翻转课堂”等多种新型教育理念、教学模式、教学方法及教学工具。格灵世界配套一系列课程设计，体现了在创新课堂中以学生为主体的宗旨，让学生充分发挥想象，自主创新、动手创作，将虚拟世界中的创想变为“现实”，从而培养高效创新能力。
                </div>
              </div>
            </div>
            <div class="character">
              <div class="left">
                <div class="headline">产品特性</div>
                <div class="list">
                  <div class="title">科学的评测</div>
                  <div class="desc">
                    3项专业能力评测，实时跟踪学生的学习路径，助力孩子成长
                  </div>
                </div>
                <div class="list">
                  <div class="title">PBL制学习</div>
                  <div class="desc">
                    以学生为主体，启发式教育，调动学生积极性增强协作、交际能力
                  </div>
                </div>
                <div class="list">
                  <div class="title">跨学科教学</div>
                  <div class="desc">
                    打破学科边界，涵盖多领域知识，培养孩子多元化解决问题的能力
                  </div>
                </div>
                <div class="list">
                  <div class="title">丰富的主题</div>
                  <div class="desc">
                    12个主题场馆，丰富的课程，让学生在学习的过程中释放创造力
                  </div>
                </div>
              </div>
              <div class="right">
                <img
                v-lazy="'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256761b4adb3/116600726.png'"
                alt=""
              />
              </div>
            </div>
          </div>
        </div>
        <!-- 格灵世界VR -->
        <div class="module gelinvr">
          <div>
            <div class="headline">格灵世界-VR互动版</div>
            <div class="introduce">
              <img
                v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/chanpin_kehu/chanpin/vr.png'"
                alt=""
              />
              <div class="right">
                <div class="title">产品介绍</div>
                <div class="desc">
                  格灵世界VR互动版采用Metaverse（元宇宙）的产品概念，营造出互动性强、趣味性强、高自由度的虚拟世界，教师和学生可以在虚拟场景中学习、互动，将学与玩深度结合，激发学生的学习兴趣。同时，基于TBL教学理念，通过丰富多彩的课程，提升学生的STEAM综合素质。
                </div>
              </div>
            </div>
            <div class="character">
              <div class="left">
                <div class="headline">产品特性</div>
                <div class="list">
                  <div class="title">寓教于乐</div>
                  <div class="desc">
                    互动性强、趣味性强的虚拟世界，吸引学生主动学习
                  </div>
                </div>
                <div class="list">
                  <div class="title">多人互动</div>
                  <div class="desc">
                    支持多人在各场景进行教学、协作、互动
                  </div>
                </div>
                <div class="list">
                  <div class="title">高自由度</div>
                  <div class="desc">
                    场景空间大、设施多，可自由漫游和探索
                  </div>
                </div>
                <div class="list">
                  <div class="title">微课课程体系</div>
                  <div class="desc">
                    可在教室场景中通过微课互动学习
                  </div>
                </div>
                <div class="list">
                  <div class="title">TBL课件授课</div>
                  <div class="desc">
                    可使用TBL课件进行授课，课程趣味性强
                  </div>
                </div>
                <div class="list">
                  <div class="title">数据分析</div>
                  <div class="desc">
                    任务过程和结果的数据分析，便于总结教学效果
                  </div>
                </div>
              </div>
              <div class="right">
                <img
                v-lazy="'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256761b359f5/140334128.png'"
                alt=""
              />
              </div>
            </div>
          </div>
        </div>
        <!-- 灵匠 -->
        <div class="module lingjiang">
          <div>
            <div class="headline">灵匠-智慧工厂</div>
            <div class="introduce">
              <img
                v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/chanpin_kehu/chanpin/gongchang.png'"
                alt=""
              />
              <div class="right">
                <div class="title">产品介绍</div>
                <div class="desc">
                  灵匠以XR为核心技术，高度还原工厂生产环境、生产流程及关键设备，是职业实操能力提升和专业技能人才培养的前沿平台。灵匠智慧工厂以“把工厂搬进学校”为理念，实现生产流程、生产工艺、生产角色、生产设备以及工业机器人使用、维修保养等全场景交互式教学以及实训。
灵匠“智慧工厂”解决职业培训及企业培训中的“三高三难”问题，并以高自由度的互动实训成为职业技能培训的选择。
                </div>
              </div>
            </div>
            <div class="character">
              <div class="left">
                <div class="headline">产品特性</div>
                <div class="list">
                  <div class="title">虚拟智慧工厂</div>
                  <div class="desc">
                    虚拟工厂漫游与实训设备相结合，拥有灵活性和便捷性
                  </div>
                </div>
                <div class="list">
                  <div class="title">智能制造学科</div>
                  <div class="desc">
                    工业机器人应用与维护方向，有完善的教学和课程体系
                  </div>
                </div>
                <div class="list">
                  <div class="title">5G与云渲染</div>
                  <div class="desc">
                    基于一体机与云渲染的工业机器人与大场景实训
                  </div>
                </div>
                <div class="list">
                  <div class="title">互动认知学习</div>
                  <div class="desc">
                    微课课程体系，在大场景中与微课模型互动学习
                  </div>
                </div>
                <div class="list">
                  <div class="title">实训与练习</div>
                  <div class="desc">
                    课后设备实训练习，便于学生巩固学习知识
                  </div>
                </div>
                <div class="list">
                  <div class="title">数据化分析</div>
                  <div class="desc">
                    实训数据统计与分析，便于课后总结教学效果
                  </div>
                </div>
              </div>
              <div class="right">
                <img
                v-lazy="'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6256761bb5fa0/588207749.png'"
                alt=""
              />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="manage" v-else>
        <!-- 灵创 -->
        <div class="module lingchuang">
          <div>
            <div class="headline">灵创</div>
            <div class="introduce">
              <img
                src="https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/4a6146010444433a3845fda133cafb48.png"
                alt=""
              />
              <div class="right">
                <div class="title">产品介绍</div>
                <div class="desc">
                  灵创是一套支持VR、AR的3D互动教学产品，包括3D编辑器和播放器两个部分。灵创具备海量的3D模型教学资源，同时支持中小学和中高职。在灵创平台，老师可以将3D模型变成一节知识点丰富的教学课件，不仅如此，灵创课件还支持多种教学终端，根据不同的终端特点，体现出个性化的教学特色。
                </div>
              </div>
            </div>
            <div class="character">
              <div class="left">
                <div class="headline">产品特性</div>
                <div class="list">
                  <div class="title">多媒体知识点标记</div>
                  <div class="desc">
                    讲授与学习的过程更为生动有趣
                  </div>
                </div>
                <div class="list">
                  <div class="title">3D模型互动</div>
                  <div class="desc">
                    在学习过程中学生参与课件交互
                  </div>
                </div>
                <div class="list">
                  <div class="title">模型动画和特效</div>
                  <div class="desc">
                    互动的知识点效果既形象又逼真
                  </div>
                </div>
                <div class="list">
                  <div class="title">跨平台多终端</div>
                  <div class="desc">
                    XR设备、手机、Pad等多终端
                  </div>
                </div>
              </div>
              <div class="right">
                <img
                  src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6268f9555ca63/317512898.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 灵点 -->
        <div class="module lingdian">
          <div>
            <div class="headline">灵点</div>
            <div class="introduce">
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6260f0be486be/758952986.png"
                alt=""
              />
              <div class="right">
                <div class="title">产品介绍</div>
                <div class="desc">
                  灵点深耕XR+教育培训领域，面向中小学、高职校、企业客户提供认知、教学、技能培训相关产品与方案。为大客户提供资源授权管理以及教师/学生-学校-区级资源三级共享服务，以XR教学数据、基础行为数据、虚拟实验评测数据、运营数据，域名定制、平台模块与样式定制、私有云部署为基本架构，满足不同客户的定制化需求。
                </div>
              </div>
            </div>
            <div class="character">
              <div class="left">
                <div class="headline">产品特性</div>
                <div class="list">
                  <div class="title">多级代理管理</div>
                  <div class="desc">
                    支持跨地域分级代理商管理客户和资源授权，丰富的数据呈现
                  </div>
                </div>
                <div class="list">
                  <div class="title">模块定制服务</div>
                  <div class="desc">
                    可据客户需求提供个性化、专属化的定制服务，功能模块灵活组合
                  </div>
                </div>
                <div class="list">
                  <div class="title">资源授权机制</div>
                  <div class="desc">
                    资源授权继承机制，一键授权学校教师及其班级学生同时资源共享
                  </div>
                </div>
                <div class="list">
                  <div class="title">内容管理完善</div>
                  <div class="desc">
                    包含VR课件、3D模型、视频、全景图片等类型的全学科优质资源
                  </div>
                </div>
                <div class="list">
                  <div class="title">实训与练习</div>
                  <div class="desc">
                    课后设备实训练习，便于学生巩固学习知识
                  </div>
                </div>
                <div class="list">
                  <div class="title">数据化分析</div>
                  <div class="desc">
                    实训数据统计与分析，便于课后总结教学效果
                  </div>
                </div>
              </div>
              <div class="right">
                <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62567e5c788f7/448737033.png"
                alt=""
              />
              </div>
            </div>
          </div>
        </div>
        <!-- 灵匠-应用商店 -->
        <div class="module lingjiangSD">
          <div>
            <div class="headline">灵匠-应用商店</div>
            <div class="introduce">
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6268f51248f60/596601664.png"
                alt=""
              />
              <div class="right">
                <div class="title">产品介绍</div>
                <div class="desc">
                  该产品采用应用商城的产品形态，包含所有的中小学、高职校及大学的应用。客户可按其所需，选择和自己学科、专业对口的教学软件。具备高度集成化、多端化适配、自动化部署、教学管理播控、统计分析的能力，并支持SDK封装输出进行二次开发和扩展。托盘应用程序可以辅助用户使用习惯的积累及售后服务。
                </div>
              </div>
            </div>
            <div class="character">
              <div class="left">
                <div class="headline">产品特性</div>
                <div class="list">
                  <div class="title">丰富的课件内容</div>
                  <div class="desc">
                    包含千余款，数十个行业的中高职应用及解决方案，用户可以随时添加到应用市场的库中下载体验。包括素材库、UI库、模型库、教学库等各类资源。
                  </div>
                </div>
                <div class="list">
                  <div class="title">广泛的多端化适配</div>
                  <div class="desc">
                    在应用商店中的软件应用具备多端化的适配能力。解决对产品硬件唯一性的壁垒，实现可跨多端设备交互及教学同步的能力。
                  </div>
                </div>
                <div class="list">
                  <div class="title">强大的教学管理</div>
                  <div class="desc">
                    具备教师教学管理能力，课程播控、用户在线状态及数据分析等。可配置设备授权、设备状态监控、应用安装状态及维护等功能。
                  </div>
                </div>
                <div class="list">
                  <div class="title">灵活的自动化部署</div>
                  <div class="desc">
                    具备自动化部署、分发、更新的能力。只需点击一键，轻松解决从部署分发到应用更新的全流程。
                  </div>
                </div>
                <div class="list">
                  <div class="title">跨平台Launcher</div>
                  <div class="desc">
                    提供基于多系统结构的应用Launcher客户端，使用户在不同系统的设备上具备统一的应用服务体验。
                  </div>
                </div>
              </div>
              <div class="right">
                <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6268f512035f7/500492725.png"
                alt=""
              />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabSelected: 0
    };
  },
  mounted() {},
  methods: {
    tabChange(tab) {
      this.tabSwlected = tab.index;
    }
  }
  //   watch: {
  //     tabSwlected(tab) {
  //       console.log('change', tab)
  //       if (tab === 0) {
  //         this.getHighList()
  //       } else {
  //         this.get中小学List()
  //       }
  //     }
  //   }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  .content {
    width: 100%;
    margin: 0 auto;
    .tab {
      width: 1200px;
      margin: 0 auto;
      margin-top: 60px;
    }
    .module {
      > div {
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 132px;
        > .headline {
          font-size: 28px;
          font-weight: 600;
          color: #444a62;
          line-height: 40px;
          position: relative;
          padding-top: 62px;
          text-align: center;
        }
        > .headline::after {
          position: absolute;
          bottom: -13px;
          left: 50%;
          margin-left: -14px;
          content: "";
          background: #ef623d;
          box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
          border-radius: 2px;
          opacity: 0.59;
          width: 28px;
          height: 5px;
        }
        .introduce {
          display: flex;
          align-items: center;
          margin-top: 73px;
          > img {
            width: 478px;
            height: 316px;
            margin-left: -14px;
          }
          .right {
            padding-left: 50px;
            flex: 1;
            display: flex;
            justify-content: center;
            flex-direction: column;
            .title {
              font-size: 32px;
              font-weight: 600;
              color: #000000;
              line-height: 45px;
              padding-left: 6px;
            }
            .desc {
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              line-height: 38px;
              margin-top: 22px;
              text-align: justify;
            }
          }
        }
        .character {
          display: flex;
          justify-content: space-between;
          margin-top: 100px;
          .left {
            flex: 1;
            .headline {
              font-size: 32px;
              font-weight: 600;
              color: #000000;
              line-height: 45px;
            }
            .list {
              margin-top: 22px;
              .title {
                font-size: 16px;
                font-weight: 500;
                color: #f27529;
                line-height: 22px;
                text-align: justify;
              }
              .desc {
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                line-height: 20px;
                margin-top: 12px;
                text-align: justify;
              }
            }
          }
          .right {
            width: 710px;
            margin-top: 94px;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    .module:nth-child(2n) {
      background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/kehu_fanwei.png);
      background-size: 100% 100%;
    }
    .weilai > div .character .right {
      margin-top: 93px;
      width: 716px;
    }
    .zhihui > div .character .right {
      margin-top: 91px;
      width: 600px;
    }
    .gelinpc > div .character .right {
      margin-top: 44px;
    }
    .gelinvr > div .character .right {
      margin-top: 66px;
    }
    .lingchuang > div .character .right {
      margin-top: -10px;
    }
    .lingjiangSD > div .character .right {
      margin-top: 66px;
    }
    // 修改tab分页标签组件样式
    /deep/.el-tabs__item {
      width: 150px;
      padding: 0;
      color: #6b738c;
      text-align: center;
      border-radius: 20px;
    }
    /deep/.el-tabs__nav {
      border-radius: 20px;
      background-color: #efefef;
    }
    /deep/.el-tabs__item:hover {
      color: #6b738c;
    }
    /deep/.el-tabs__item.is-active,
    /deep/.el-tabs__item.is-active:hover {
      color: #fff;
      background: #f27529 !important;
    }
    /deep/.el-tabs__active-bar,
    /deep/.el-tabs__nav-wrap::after {
      height: 0;
    }
    // 修改页面分页组件样式
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      color: #fff;
      border: 0;
      background: #f27529 !important;
    }
  }
}
</style>
